/* tslint:disable */
/* eslint-disable */
/**
 * Sports App Training Plans
 * API for the Sports App Training Plans
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChangeUsernameDTO
 */
export interface ChangeUsernameDTO {
    /**
     * 
     * @type {string}
     * @memberof ChangeUsernameDTO
     */
    username: string;
}

/**
 * Check if a given object implements the ChangeUsernameDTO interface.
 */
export function instanceOfChangeUsernameDTO(value: object): value is ChangeUsernameDTO {
    if (!('username' in value) || value['username'] === undefined) return false;
    return true;
}

export function ChangeUsernameDTOFromJSON(json: any): ChangeUsernameDTO {
    return ChangeUsernameDTOFromJSONTyped(json, false);
}

export function ChangeUsernameDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChangeUsernameDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'username': json['username'],
    };
}

export function ChangeUsernameDTOToJSON(json: any): ChangeUsernameDTO {
    return ChangeUsernameDTOToJSONTyped(json, false);
}

export function ChangeUsernameDTOToJSONTyped(value?: ChangeUsernameDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'username': value['username'],
    };
}

